__turbopack_context__.v({
  "UiDivider": "divider-module__6fPu9q__UiDivider",
  "UiDivider__dashed": "divider-module__6fPu9q__UiDivider__dashed" + " " + "divider-module__6fPu9q__UiDivider",
  "UiDivider__dotted": "divider-module__6fPu9q__UiDivider__dotted" + " " + "divider-module__6fPu9q__UiDivider",
  "UiDivider__solid": "divider-module__6fPu9q__UiDivider__solid" + " " + "divider-module__6fPu9q__UiDivider",
});
